import React, { Component, Fragment } from 'react';
import { string, array } from 'prop-types';
import classnames from 'classnames/bind';

import Icon from 'foundations/Icons/Icon';
import Input from './Input';
import InputLabel from 'elements/Inputs/InputLabel';
import WithValidation from './WithValidation';
import { Consumer } from './FormField';

import cvvStyles from './CVVInput.css';
import formFieldStyles from './FormField.css';

const cx = classnames.bind(cvvStyles);

export default class CVVInput extends Component {
  static propTypes = {
    placeholder: string,
    type: string,
    customClasses: string,
    validations: array,
    label: string,
  };

  static defaultProps = {
    placeholder: '123',
    type: 'number',
    customClasses: ''
  };

  state = { value: '' };

  handleChange = e => {
    const { value } = e.currentTarget;

    if (value.length > 3) {
      return false;
    }

    this.setState({ value });
  }

  render() {
    const { placeholder, type, customClasses, validations, label } = this.props;
    const { value } = this.state;
    const wrapperClasses = cx({ isFilled: value.length } );

    return (
      <div className={wrapperClasses}>
        <Consumer>
            {sharedProps =>
              <WithValidation
                value={value}
                validations={validations}
                render={
                  error => (
                    <Fragment>
                      <InputLabel {...sharedProps} label={label} />
                      <div className="relative">
                        <Input
                          sharedProps={sharedProps}
                          customClasses={`${customClasses} ${cvvStyles.CVVInput}`}
                          placeholder={placeholder}
                          onChange={this.handleChange}
                          value={value}
                          error={error}
                          type={type}
                        />
                        <Icon
                          icon={'payment'}
                          type={'30'}
                          customClasses={formFieldStyles.iconRight}
                        />
                      </div>
                    </Fragment>
                  )
                }
              />
            }
          </Consumer>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/uis/elements/Inputs/CVVInput.js